/**
 * 右键上下文菜单注册表（P0-3d B-2）——纯数据/纯函数，可离线测。
 *
 * 设计（对齐蓝图 §11.7 R-1「五类对象最小菜单集」）：
 *  · 菜单不写死在组件里，而由「目标类型 → 菜单项列表」的注册表驱动；
 *    新增一类目标/一个动作只改这里，UI 与派发解耦；
 *  · 菜单项只声明 action id + 文案，具体行为由页面 dispatchAction 落地——
 *    注册表不 import store/组件，保持纯净可测。
 *
 * 目标类型来自当前选中态：角色 / 道具 / 机位 / 逐骨 / 空白（视口无选中）。
 */

export type MenuTarget = 'character' | 'prop' | 'camera' | 'bone' | 'empty';

export type MenuAction =
  | 'duplicate'
  | 'delete'
  | 'resetTransform'
  | 'clearPose'
  | 'clearBoneOverride'
  | 'enterCameraView'
  | 'setActiveCamera'
  | 'resetView'
  | 'deselect';

export interface MenuItem {
  action: MenuAction;
  label: string;
  /** 危险操作（删除）用警示色，与全站 danger token 对齐 */
  danger?: boolean;
}

const MENU: Record<MenuTarget, readonly MenuItem[]> = {
  character: [
    { action: 'duplicate', label: '复制' },
    { action: 'clearPose', label: '清除姿势' },
    { action: 'resetTransform', label: '重置变换' },
    { action: 'delete', label: '删除', danger: true },
  ],
  prop: [
    { action: 'duplicate', label: '复制' },
    { action: 'resetTransform', label: '重置变换' },
    { action: 'delete', label: '删除', danger: true },
  ],
  camera: [
    { action: 'enterCameraView', label: '进入该视角' },
    { action: 'duplicate', label: '复制机位' },
    { action: 'delete', label: '删除机位', danger: true },
  ],
  bone: [
    { action: 'clearBoneOverride', label: '清除该骨覆盖' },
    { action: 'clearPose', label: '清除全部姿势调整' },
  ],
  empty: [
    { action: 'resetView', label: '重置视角' },
    { action: 'deselect', label: '取消所有选择' },
  ],
};

/** 某目标类型的菜单项（返回副本，防调用方误改注册表） */
export function menuFor(target: MenuTarget): MenuItem[] {
  return MENU[target].map((item) => ({ ...item }));
}

/** 全部目标类型（供遍历/测试） */
export const MENU_TARGETS: readonly MenuTarget[] = [
  'character',
  'prop',
  'camera',
  'bone',
  'empty',
];
